<div class="sub-header  left-width"  *ngIf="auth.IsAuthUser()" [ngClass]="{'mat-elevation-z5' : true, 'sticky' : isSticky}">
    <!-- 'logged-out' : !auth.IsAuthUser()  -->
      <div class="header-step">
          <h2 class="heading-title">
              {{header}}
          </h2>
          <ng-container *ngIf="showStage!= 0" >
          <!-- <span class="steps" *ngIf="currentStage != '-1'">Step {{currentStage}} of {{totalStage}}</span> -->
          <button *ngIf="currentStage != '-1'" class="withdraw-btn" (click)="disableOpportunity()">Withdraw Application</button>
        </ng-container>
  
      </div>
  
      <!-- <div class="stepper">
          <ul class="progressbar"> 
              <li *ngFor="let element of progressBar" [class]="element.classStage"></li>
          </ul>
      </div> -->
     
      <div class="stepper-circle "  [ngClass]="currentStage == '-1' ? 'stepper-circle-hidden'  :'' "  >
        
        <div role="progressbar" #circleBar  class="stepper-value">step <br>{{currentStage}} of {{totalStage}}</div>
        <!-- <mat-label>Step {{currentStage}}</mat-label> -->
      </div>
  
  </div>
  <div class="sub-header logged-out"  *ngIf="!auth.IsAuthUser()">
      <div class="header-step">
          <h2 class="heading-title">
              {{header}}
          </h2>
          <span class="steps" >STEP {{currentStage}} OF {{totalStage}}</span>
          
      </div>
  
      <!-- <div class="stepper">
          <ul class="progressbar"> 
              <li *ngFor="let element of progressBar" [class]="element.classStage"></li>
             
          </ul>
      </div> -->
      <!-- step <br>{{currentStage}} of {{totalStage}} -->
      <div class="stepper-circle "  *ngIf="auth.IsAuthUser()"  >
        <div role="progressbar"   class="stepper-value"></div>
        <!-- <mat-label>Step {{currentStage}}</mat-label> -->
      </div>
  
  </div>
